import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { RendererType, Section } from '../../../editor-container/editor-model';
import { Observable, Subject, Subscription } from 'rxjs';
import { ContentElement, ContentElementEnum, ContentEnum, GridCell, HeadFootEnum, RowCell } from '@urbannex/storethemes';
import { NbDialogRef, NbDialogService, NbMenuBag, NbMenuComponent, NbMenuItem, NbMenuService, NbTabComponent, NbTabsetComponent } from '@nebular/theme';
import { CellEditorStoreService, LastActionEnum } from '../../cell-editor-store.service';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { take, takeUntil } from 'rxjs/operators';
import exportFromJSON from 'export-from-json';
import { SampleImageDirectoryComponent } from '../../sample-image-directory/sample-image-directory.component';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { FieldSummaryPopoverComponent } from '../field-summary-popover/field-summary-popover.component';
import { EditState } from '../../../model';
import { NbIconLibraries } from '@nebular/theme';
import { ContentElementCtx, editMenuItems, mainMenuItems } from './main-menu-items';
import { customIcons } from './custom-editor-icons';
import { CellOptionsService } from './cell-options.service';



@Component({
  selector: 'ngx-editor-dialog',
  templateUrl: './editor-dialog.component.html',
  styleUrls: ['./editor-dialog.component.scss']
})
export class EditorDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() title: string;
  @Input() imgSrc: string;
  section: Section;
  @Input() cellId: string;
  selectedCell$: Observable<GridCell | RowCell>;
  imgSrc$: Subscription
  // selectedCell: GridCell | RowCell;
  @Input() dialogWidth: number;
  @Input() cellLayoutThumbs: string;

  mainMenuItems = mainMenuItems;

  screenSize: string;

  rendererType: RendererType;

  selectorPosChange$: Subscription;

  contentEnum: ContentEnum;

  imageUpdate$: Subscription;
  lastAction$: Subscription;

  layoutClass: string;
  fillClass: string;
  fillColor: string;

  sameLayout = false;
  sameTheme = false;

  fieldSummaryPop: any = FieldSummaryPopoverComponent;

  contentElements: ContentElement[];

  @ViewChild('editorDialogTabs', { read: ElementRef }) tabsHost: ElementRef;
  @ViewChild('editorDialogTabs') tabs: NbTabsetComponent;
  @ViewChild("bgTab") bgTabEl: NbTabComponent;
  @ViewChild("layoutTab") layoutTabEl: NbTabComponent;
  @ViewChild("colourTab") colourTabEl: NbTabComponent;
  @ViewChild("contentTab") contentTabEl: NbTabComponent;
  @ViewChild("linkTab") linkTabEl: NbTabComponent;
  @ViewChild("imageTab") imageTabEl: NbTabComponent;

  @ViewChild('expandableFooter', { read: ElementRef }) footer: ElementRef<HTMLElement>
  @ViewChild(NbMenuComponent, { read: ElementRef }) menuElementRef!: ElementRef;

  expandedFooter = true;
  selectedTabTitle: string;
  posChange: string;

  hasLoaded: boolean = false;

  private destroy$: Subject<void> = new Subject<void>();


  attributeMenuItems: NbMenuItem[] = [];

  // Array to hold all menu items and their children
  sectionCells: NbMenuItem[] = [];

  // Main context menu with parent items only
  contextMenuItems: NbMenuItem[] = [];

  // Child menu that updates based on selection
  childMenuItems: NbMenuItem[] = [];

  editMenuItems: NbMenuItem[] = editMenuItems;

  constructor(
    protected ref: NbDialogRef<EditorDialogComponent>,
    private el: ElementRef,
    private cellEditorStoreService: CellEditorStoreService,
    private cellOptionsService: CellOptionsService,
    private dialogService: NbDialogService,
    private previewEditStoreService: PreviewEditStoreService,
    private communicator: IframeCommunicationService,
    private iconLibraries: NbIconLibraries,
    private menuService: NbMenuService) {
    this.menuService.onItemClick().subscribe((menuBag) => {
      this.resolveTarget(menuBag);
    });
    this.previewEditStoreService.selectedSection$.subscribe((data) => {
      console.log(data)
      this.section = data;
    })
  }


  ngOnInit(): void {
    // console.log("SelectedCell Track received: ", this.selectedCell);
    console.log("SelectedSection Track received: ", this.section);
    this.iconLibraries.registerSvgPack('custom-icons', customIcons);
    this.configDialog();
    this.screenSize = "default";
    if (this.rendererType != undefined) {
      if ((this.rendererType).includes(".")) {
        const enumKey = this.rendererType.split('.')[1] as keyof typeof RendererType;
        this.rendererType = RendererType[enumKey];
        console.log(this.rendererType);
      }
    }

    // this.rendererType = this.section.rendererType;
    const initialCell = this.resolveSelectedCell(this.cellId);
    this.initCellStore(initialCell);
    this.cellOptionsService.initializeSelectionOptions(initialCell);
    this.contentEnum = initialCell.contentEnum ? initialCell.contentEnum : ContentEnum.GENERAL_TEXT;
    this.updateChildMenu(initialCell.cellId)
    this.selectedCell$ = this.cellEditorStoreService.selectedCell$;

    this.lastAction$ = this.cellEditorStoreService.lastActionState$.subscribe((lastAction: LastActionEnum) => {
      if (lastAction != undefined) {
        this.manageTabs(lastAction);
      }

    })
    this.selectorPosChange$ = this.cellEditorStoreService.selectorPosChange$.pipe(takeUntil(this.destroy$)).subscribe(posChange => {
      this.posChange = posChange;
    })
    this.previewEditStoreService.selectedSection$.subscribe((data) => {
      console.log(data);

      let rendererType = data.rendererType;
      if ((rendererType).includes(".")) {
        const enumKey = data.rendererType.split('.')[1] as keyof typeof RendererType;
        rendererType = RendererType[enumKey];
      }
      console.log(rendererType);
      switch (rendererType) {
        case RendererType.GRID:
          console.log("We have a grid baby");
          const gridCells: GridCell[] = data.sectionData.gridOptions.gridCells;
          gridCells.forEach(gridCell => {
            console.log(gridCell);
            let cntEnum: any;
            if (gridCell.contentEnum) {
              if ((gridCell.contentEnum).includes(".")) {
                console.log("Enum has dot", gridCell.contentEnum);
                const enumKey = gridCell.contentEnum.split('.')[1] as keyof typeof ContentEnum;
                cntEnum = ContentEnum[enumKey];
              } else {
                cntEnum = ContentEnum[gridCell.contentEnum]
              }
              if (cntEnum == undefined) {
                cntEnum = gridCell.contentEnum;
              }
            }
            const cellId = gridCell.cellId;
            console.log("Content Enum resolved to ...", cntEnum);
            const menuItem: NbMenuItem = { title: cntEnum, data: { id: cellId } };
            if (gridCell.contentElements?.length > 0) {
              menuItem.children = [];
              gridCell.contentElements.forEach(cntEl => {
                let childItem: any;
                let cntElEnum: any;
                if (cntEl.contentElementEnum) {
                  console.log(cntEl.contentElementEnum);
                  if ((cntEl.contentElementEnum).includes(".")) {
                    console.log("Enum has dot", cntEl.contentElementEnum);
                    const enumKey = cntEl.contentElementEnum.split('.')[1] as keyof typeof ContentElementEnum;
                    cntElEnum = ContentElementEnum[enumKey];
                  } else {
                    cntElEnum = ContentElementEnum[cntEl.contentElementEnum]
                  }
                  childItem = <NbMenuItem>{ "title": cntElEnum }
                } else {
                  childItem = <NbMenuItem>{ "title": "No Text" }
                }
                const data: ContentElementCtx = {
                  elId: cntEl.elId,
                  contentElement: cntEl,
                  cellId: cellId
                };

                childItem.data = data
                menuItem.children.push(childItem)
              })
            }
            this.sectionCells.push(menuItem);
          })
          console.log(this.sectionCells)
          this.createContextMenu(this.sectionCells);
          break;
        case RendererType.BANNER:
        case "banner":
          console.log("We're in the banner baba")
          const rowCells = data.sectionData.bannerOptions.rowCells;
          console.log(rowCells);
          rowCells.forEach(gridCell => {
            console.log(gridCell);
            const menuItem: NbMenuItem = { title: "No Title" };
            if (gridCell.contentEnum != undefined && gridCell.contentEnum != null) {
              menuItem.title = gridCell.contentEnum;
            } else if (gridCell.contentElementEnum != undefined && gridCell.contentElementEnum != null) {
              menuItem.title = gridCell.contentElementEnum
            }
            // console.log(menuItem);
            if (gridCell.contentElements?.length > 0) {
              menuItem.children = [];
              gridCell.contentElements.forEach((cntEl: ContentElement) => {
                let childItem: any;
                let cntEnum: any;
                if (cntEl.contentElementEnum) {
                  console.log(cntEl.contentElementEnum);
                  if ((cntEl.contentElementEnum).includes(".")) {
                    const enumKey = cntEl.contentElementEnum.split('.')[1] as keyof typeof ContentElementEnum;
                    cntEnum = ContentElementEnum[enumKey];
                  } else {
                    cntEnum = ContentElementEnum[cntEl.contentElementEnum]
                  }
                  childItem = <NbMenuItem>{ "title": cntEnum }
                } else {
                  childItem = <NbMenuItem>{ "title": "No Text" }
                }
                const data: ContentElementCtx = {
                  elId: cntEl.elId,
                  contentElement: cntEl
                };

                childItem.data = data
                menuItem.children.push(childItem)
              })
            }
            this.sectionCells.push(menuItem);
          })
          break;
        default:
          console.log("couldn't reolve a rendererType for ...", data.rendererType)
          break;
      }
      setTimeout(() => {
        this.hasLoaded = true;
      }, 2);

    });
    this.cellOptionsService.menuItems$.pipe(takeUntil(this.destroy$)).subscribe(items => {
      console.log(items);
      this.mainMenuItems = [...items, ...mainMenuItems];
    })
    this.imgSrc$ = this.cellEditorStoreService.imgSrc$.pipe(takeUntil(this.destroy$)).subscribe(imgSrc => {
      console.log("Image Source updated to:", imgSrc);
    });

  }

  ngAfterViewInit(): void {
    // console.log(this.selectedCell);
    // this.contentEnum = this.selectedCell.contentEnum ? this.selectedCell.contentEnum : ContentEnum.GENERAL_TEXT;
    // this.updateChildMenu(this.selectedCell.cellId)
    /* let previewHost = <HTMLElement>(this.el.nativeElement).querySelector('.preview-wrapper');
    if(previewHost != undefined){
      let header = <HTMLElement>previewHost.querySelector('.header');
      if(header != undefined){
        let headerStyles = getComputedStyle(header);
        let headerClassList:DOMTokenList = header.classList;
        this.getHeaderClass(headerClassList);
        let rgbColor = headerStyles.color;
        if(rgbColor != undefined){
          this.setHeaderColor(rgbColor);
        }
        let headerFnt = headerStyles.fontFamily;
        let headerFntWgt = headerStyles.fontWeight;
        console.log({family:headerFnt,weight:headerFntWgt,decor:headerStyles.textDecorationLine,size:headerStyles.fontSize,italic:headerStyles.fontStyle,padding:headerStyles.padding,margin:headerStyles.margin,border:headerStyles.border});
      }else{
        console.log("Can find header")
      }

    }else{
      console.log("Cant find previewHost")
    } */
    // Make tabs resizeable
    const _tabHost = <HTMLElement>this.tabsHost.nativeElement;
    _tabHost.style.resize = "vertical";
  }

  configDialog(): void {
    const host = <HTMLElement>this.el.nativeElement;

    const dialogContainer = <HTMLElement>host.parentElement;
    dialogContainer.style.width = "100%";
    const overlayPane = <HTMLElement>dialogContainer.parentElement;
    overlayPane.style.width = "100%";
    /* const overlayWrapper = <HTMLElement>overlayPane.parentElement;
    overlayWrapper.style.removeProperty('justify-content');

    overlayWrapper.style.setProperty("justify-content","end");
    overlayWrapper.classList.add('right');
    dialogContainer.style.setProperty("position","absolute");
    dialogContainer.style.setProperty("right","0");
    dialogContainer.style.setProperty("top","15px");
    dialogContainer.style.setProperty("margin-right","260px");
    dialogContainer.style.setProperty("width",this.dialogWidth+"px"); */
  }
  initCellStore(selectedCell: GridCell | RowCell): void {
    console.log(selectedCell);
    const layoutClass = selectedCell.layoutClass ? selectedCell.layoutClass : "cell-layout-default";
    const themeClass = selectedCell.themeClass ? selectedCell.themeClass : "cell-theme-default";
    const headerFooterOpt = selectedCell.headerFooterEnum ? selectedCell.headerFooterEnum : HeadFootEnum.BOTH;
    this.cellEditorStoreService.init(selectedCell, null, layoutClass, themeClass, headerFooterOpt);
  }


  manageTabs(lastAction: LastActionEnum): void {

    switch (lastAction) {
      case LastActionEnum.INIT:

        break;
      case LastActionEnum.BG_SET:
        this.selectTab(this.imageTabEl);
        break;
      case LastActionEnum.IMAGE_SET:
        this.selectTab(this.layoutTabEl);
        break;
      case LastActionEnum.LAYOUT_SET:
        this.selectTab(this.colourTabEl);
        break;
      case LastActionEnum.THEME_SET:
        this.selectTab(this.contentTabEl);
        break;
      case LastActionEnum.CONTENT_SET:
        this.selectTab(this.bgTabEl);
        break;

      default:
        break;
    }
  }

  selectTab(tab: NbTabComponent): void {
    if (tab != undefined) {
      if (tab.disabled != undefined && tab.disabled == true) {
        tab.disabled = false;
      }
      this.tabs.selectTab(tab);
    }
  }

  onLayouSelected(selectedClass: string) {
    this.layoutClass = selectedClass;
  }

  close() {
    console.log("SelectedSection Track on close:", this.section)
    this.ref.close(this.resolveSelectedCell(this.cellId));
  }

  onSameLayout(e) {
    this.sameLayout = true;
  }

  onSameTheme(e) {
    this.sameTheme = true;
  }

  onSave(e) {
    /* this.cellEditorStoreService.imgSrc$.subscribe(imgScr => {
      this.selectedCell.imgSrc = imgScr
    })
    this.cellEditorStoreService.layoutClass$.subscribe(layoutClass => {
      this.selectedCell.layoutClass = layoutClass;
    }) */
    this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe((selectedCell: GridCell | RowCell) => {
      this.cellEditorStoreService.cellState$.subscribe(state => {
        // selectedCell.fillClass = state.fillClass;
        // selectedCell.fillColor = state.fillColor;
        // selectedCell.heightCls = state.heightClass;
        // Header Stuff
        if (selectedCell.heading) {
          selectedCell.hdrParBgColor = state.hdrParBgColor;
          selectedCell.hdrContLayoutClass = state.hdrContLayoutClass;
          selectedCell.heading.headerTxtClr = state.headerTextColor;
          selectedCell.heading.hdrFontFam = state.hdrFontFam;
          selectedCell.heading.hdrContBgClr = state.hdrContBgClr;
          selectedCell.heading.hdrFntSizeClass = state.hdrFontSizeClass;
          selectedCell.heading.hdrPadCust = state.hdrPadCls;
        }

        // selectedCell.imgSrc = state.imgSrc;

      })
      if (this.sameLayout) {
        this.previewEditStoreService.setSameLayout(selectedCell.layoutClass)
      }
      if (this.sameTheme) {
        this.previewEditStoreService.setSameTheme(selectedCell)
      }
      if (this.rendererType == "testimonials") {
        this.previewEditStoreService.setRowCellsSame(selectedCell);
      }
      console.log(selectedCell);
      console.log("SelectedSection Track on save:", this.section)
      this.previewEditStoreService.updateSelectedSection({ ...this.section });
      console.log("Updating editState to ... ", EditState.EDITING)
      this.previewEditStoreService.updateEditState(EditState.EDITING)
      this.ref.close(selectedCell);
    })
  }

  onUndo() {

  }

  onCancel() {

  }

  onChangeTabImages(tab: NbTabComponent) {
    this.selectedTabTitle = tab.tabTitle;
    switch (tab.tabTitle) {
      case "Images":
        this.cellEditorStoreService.updateLastActionState(LastActionEnum.INIT);
        break;

      default:
        break;
    }
  }

  rgbToHex(r, g, b): string {
    return "#" + r.toString(16) + g.toString(16) + b.toString(16);
  }

  // Function to extract numbers

  setHeaderColor(str: string): void {
    // Input string
    // let str = "foo35bar5jhkj88";
    console.log(str)

    // Using match with regEx
    const matches = str.match(/\d+/g);

    // Display output if number extracted
    if (matches) {
      console.log(matches[0] + ', ' + matches[1] + ', ' + matches[2]);
      const r = <number><any>matches[0];
      const g = <number><any>matches[1];
      const b = <number><any>matches[2];
      const rgbToHex = this.rgbToHex(r, g, b);
      if (rgbToHex != undefined) {
        this.cellEditorStoreService.updateHeaderTxtColor(rgbToHex)
      }
    }
    // return numbers
  }

  getHeaderClass(headerClassList: DOMTokenList): void {
    for (let i = 0; i < headerClassList.length; i++) {
      console.log(headerClassList[i])
      for (let j = 1; j < 7; j++) {
        const headerClass = "h" + j;
        // console.log({inList:headerClassList[i],fromList:headerClass})
        if (headerClassList[i] == headerClass) {
          // console.log("Found it: "+headerClass);
          this.cellEditorStoreService.updateHdrClass(headerClass);
          break;
        }
      }
    }
  }

  toggleFooter() {
    this.footer.nativeElement.classList.toggle("expanded");
    this.expandedFooter = !this.expandedFooter;
  }



  pickGalleryImage(contentElement: ContentElement) {
    this.cellEditorStoreService.updateActiveSelector(contentElement);
    this.dialogService.open(SampleImageDirectoryComponent, {
      context: {
        title: 'This is a title passed to the dialog component',
        contentEnum: ContentEnum.GALLERY,
        elId: contentElement.elId
      },
    });
  }

  setScreen(size: string) {
    this.screenSize = size;
  }

  export() {
    this.cellEditorStoreService.selectedCell$.pipe(takeUntil(this.destroy$)).subscribe(cell => {
      const fileName = "cellDefinition"
      const exportType = 'json';
      const jsonData = JSON.stringify(cell, null, 2);
      jsonData.replace(/\\n/g, '');
      const data = { "cellDefinition": cell };
      console.log(data);
      exportFromJSON({ data, fileName, exportType });
    })
  }

  fieldSummary() {

  }

  loadResponsive(e) {
    this.communicator.sendFromParent({ id: "responsiveConf", data: e })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  /**
   *
   * @param menuBag From the menuService
   */
  resolveTarget(menuBag: NbMenuBag): void {
    console.log(menuBag);
    const target: string = menuBag.tag;
    const context = menuBag.item.data;
    // let context:string = menuBag.item.data["context"]?menuBag.item.data["context"]:null;

    switch (target) {
      case "sectionEditorMenu":
        console.log(context)
        if (context["id"] != undefined) {
          this.updateChildMenu(context.id);
          // Change selected cell
          this.updateSelectedCell(context.id);
        }
        break;
      case "editorSelector":
        console.log(context)
        if (context["elId"] != undefined) {
          const contentElement: ContentElement = context["contentElement"];
          this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(contentElement);
          // this.cellEditorStoreService.updateActiveSelector(contentElement);
        } else if (context["elId"] != undefined) {

        }
        break;
      default:
        break;
    }

    /* this.previewEditStoreService.selectedSection$.pipe(take(1)).subscribe((section) => {
      console.log(section);
      this.cellEditorStoreService.selectedCell$.subscribe(data => {
        console.log(data)
        if (data) {
          this.selectedCell = { ...data };
        }
        this.cellEditorStoreService.activeSelector$.subscribe(data => {
          console.log(data)
        })
      })
    }) */
  }

  createContextMenu(sectionCells: NbMenuItem[]): void {
    // Only create context menu if not already created
    if (this.contextMenuItems.length > 0) {
      return;
    }
    // Extract parent items only for context menu
    this.contextMenuItems = sectionCells.map(item => ({
      title: item.title + ' [' + item.data.id + ']',
      data: item.data
    }));
  }

  updateChildMenu(cellId: string): void {
    const selectedItem = this.sectionCells.find(item => item.data.id === cellId);
    if (selectedItem && selectedItem.children) {
      this.childMenuItems = selectedItem.children;
    } else {
      this.childMenuItems = [];
    }
    console.log(this.childMenuItems);
  }
  // Update selected cell in store based on cellId
  /* updateSelectedCell(cellId: string): void {
    let cells: GridCell[] | RowCell[];
    this.previewEditStoreService.selectedSection$.pipe(take(1)).subscribe((section) => {
      console.log(section);
      switch (this.rendererType) {
        case RendererType.GRID:
          cells = section.sectionData.gridOptions.gridCells;
          console.log("443", cells);
          console.log("443", this.section.sectionData.gridOptions.gridCells);
          break;
        case RendererType.BANNER:
        case "banner":
          const rowCells: RowCell[] = section.sectionData.bannerOptions.rowCells;
          break;
        default:
          break;
      }
    });
    const cellToSelect = cells.find(cell => cell.cellId === cellId);
    if (cellToSelect) {
      console.log("Selected Cell found:", cellToSelect);
      console.log("imgSrc BEFORE copy:", cellToSelect.imgSrc);
      // Create a deep copy of the selected cell to avoid reference issues
      this.selectedCell = { ...cellToSelect };
      console.log("imgSrc AFTER copy:", this.selectedCell.imgSrc);
      // Update local properties
      this.contentEnum = this.selectedCell.contentEnum;
      this.cellId = this.selectedCell.cellId;
      console.log("This instance set to new", this.selectedCell);
      // update local selectedCell
      this.initCellStore(this.selectedCell);
      // Update store
      const sectionData = { ...this.section.sectionData, selectedCell: cellToSelect };
      this.section = { ...this.section, sectionData: sectionData };
      console.log("443", this.section)
      this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe((selectedCell) => {
        console.log(selectedCell)
      })
      // Update store
      // this.cellEditorStoreService.updateSelectedCell({ ...cellToSelect });
      // this.initCellStore(this.selectedCell);
    } else {
      console.log("Selected Cell NOT found for id:", cellId);
    }
  } */

  updateSelectedCell(cellId: string): void {
    this.previewEditStoreService.selectedSection$
      .pipe(take(1))
      .subscribe((section) => {
        let cells: GridCell[] | RowCell[];
        switch (this.rendererType) {
          case RendererType.GRID:
            cells = section.sectionData.gridOptions.gridCells;
            break;
          case RendererType.BANNER:
          case "banner":
            cells = section.sectionData.bannerOptions.rowCells;
            break;
          default:
            return; // Exit early if no valid renderer type
        }
        const cellToSelect = cells?.find(cell => cell.cellId === cellId);

        if (cellToSelect) {
          console.log("Selected Cell found:", cellToSelect);
          console.log("imgSrc:", cellToSelect.imgSrc);

          // Update local properties
          this.contentEnum = cellToSelect.contentEnum;
          this.cellId = cellToSelect.cellId;

          // Re-initialize the store with the new cell
          // This will update the selectedCell$ observable automatically
          this.initCellStore(cellToSelect);

          // Update the section in the preview store if needed
          const sectionData = {
            ...section.sectionData,
            selectedCell: cellToSelect
          };
          this.section = { ...section, sectionData: sectionData };

          console.log("Store updated with new cell");
        } else {
          console.warn("Selected Cell NOT found for id:", cellId);
        }
      });
  }

  resolveSelectedCell(cellId): GridCell {
    console.log("Resolving selectedCell for id:", cellId);
    let cells: GridCell[] | RowCell[];
    this.previewEditStoreService.selectedSection$.pipe(take(1)).subscribe(section => {
      console.log("SelectedSection Track inside resolver", section)
      cells = section.sectionData.gridOptions.gridCells;
    })
    let selectedCell: GridCell | RowCell;
    if (cells != undefined && cells.length > 0) {
      console.log(cells)
      selectedCell = cells.find(cell => cell.cellId == cellId);
    }
    console.log("Resolved selectedCell:", selectedCell);
    return selectedCell;
  }

}
